import { KycLevel, KycStepName, KycStepType, LimitPeriod, Utils, useUserContext } from '@dfx.swiss/react';
import { useMemo } from 'react';
import { useSettingsContext } from '../contexts/settings.context';
import { useNavigation } from './navigation.hook';
export function useKycHelper() {
    const { translate } = useSettingsContext();
    const { user } = useUserContext();
    const { navigate } = useNavigation();
    const periodMap = {
        [LimitPeriod.DAY]: 'per 24h',
        [LimitPeriod.YEAR]: 'per year',
    };
    const stepMap = {
        [KycStepName.CONTACT_DATA]: 'Contact data',
        [KycStepName.PERSONAL_DATA]: 'Personal data',
        [KycStepName.IDENT]: 'Identification',
        [KycStepName.FINANCIAL_DATA]: 'Additional data',
        [KycStepName.DOCUMENT_UPLOAD]: 'Document upload',
    };
    const typeMap = {
        [KycStepType.AUTO]: 'auto',
        [KycStepType.VIDEO]: 'video',
        [KycStepType.MANUAL]: 'manual',
    };
    const limit = user && limitToString(user.tradingLimit);
    const isComplete = user && user.kyc.level >= KycLevel.Completed;
    function start() {
        navigate('/kyc');
    }
    function startStep(stepName, stepType) {
        const step = stepName + (stepType ? `/${stepType}` : '');
        navigate({ pathname: '/kyc', search: `step=${step}` });
    }
    // formatting
    function levelToString(level) {
        switch (level) {
            case -10:
                return translate('screens/kyc', 'Terminated');
            case -20:
                return translate('screens/kyc', 'Rejected');
            default:
                return translate('screens/kyc', `Level {{level}}`, { level });
        }
    }
    function limitToString({ limit, period }) {
        return `${Utils.formatAmount(limit, 0)} CHF ${translate('screens/kyc', periodMap[period])}`;
    }
    function nameToString(stepName) {
        return translate('screens/kyc', stepMap[stepName]);
    }
    function typeToString(stepType) {
        return translate('screens/kyc', typeMap[stepType]);
    }
    return useMemo(() => ({
        start,
        startStep,
        isComplete,
        defaultLimit: { limit: 1000, period: LimitPeriod.DAY },
        limit,
        levelToString,
        limitToString,
        nameToString,
        typeToString,
    }), [user, translate]);
}
